interface Props {
  balance: number;
  multiplier: number;
  nextMultiplier: number | null;
  picks: number;
  seedHash?: string;
}

export function HUD({ balance, multiplier, nextMultiplier, picks, seedHash }: Props) {
  return (
    <div className="flex items-start justify-between p-3 gap-2">
      <div className="hud-chip">
        <div className="text-[10px] uppercase tracking-wider text-cs-muted">Balance</div>
        <div className="text-lg font-bold text-cs-gold tabular-nums">
          {balance.toLocaleString()}
        </div>
      </div>

      <div className="hud-chip text-center min-w-[92px]">
        <div className="text-[10px] uppercase tracking-wider text-cs-muted">Multiplier</div>
        <div className="text-xl font-extrabold text-cs-green tabular-nums">
          ×{multiplier.toFixed(2)}
        </div>
        {nextMultiplier !== null && (
          <div className="text-[10px] text-cs-muted tabular-nums">
            next ×{nextMultiplier.toFixed(2)}
          </div>
        )}
      </div>

      <div className="hud-chip text-right">
        <div className="text-[10px] uppercase tracking-wider text-cs-muted">Wires</div>
        <div className="text-lg font-bold tabular-nums">{picks}/7</div>
        {seedHash && (
          <div className="text-[9px] text-cs-muted font-mono truncate max-w-[96px]">
            {seedHash.slice(0, 10)}…
          </div>
        )}
      </div>
    </div>
  );
}
